import api from "./apiService";

// Lookup-endpoint responses aren't uniformly shaped, so this pulls out
// whichever array-of-records is actually there and maps each record's
// id/label onto a plain { id, name } pair.
//
// Shapes confirmed against the real backend (iptestapi.irbureau.com):
//   - /survey/countries            -> { id, country_name }
//   - /survey/sectors              -> { question_answer_id, answer }
//   - /company/fetch-companyNames  -> { company_id, company_name }
// Most of the other /user/* lookup endpoints (household income, work status,
// seniority level, business model, ...) read like the same underlying
// "survey question answer" table sectors comes from, so question_answer_id/
// answer is checked first; the rest of the chain is a defensive fallback for
// whatever the remaining endpoints turn out to use. If a dropdown still
// shows no options after its API call succeeds, the record's id/name keys
// most likely aren't in this list yet - inspect the real response (see
// scratchpad/pw's curl checks against iptestapi.irbureau.com) and add them.
export const normalizeOptions = (body) => {
  const list = Array.isArray(body)
    ? body
    : body?.data?.data ?? body?.data ?? body?.list ?? body?.result ?? [];

  if (!Array.isArray(list)) return [];

  return list
    .map((item) => {
      if (item === null || typeof item !== "object") {
        return { id: item, name: String(item) };
      }
      const id =
        item.question_answer_id ??
        item.state_id ??
        item.id ??
        item.company_id ??
        item.value ??
        item._id ??
        item.code ??
        item.key;
      const name =
        item.answer ??
        item.country_name ??
        item.state_name ??
        item.sector_name ??
        item.industry_name ??
        item.department_name ??
        item.function_name ??
        item.company_name ??
        item.name ??
        item.label ??
        item.title ??
        item.text ??
        (id !== undefined ? String(id) : "");
      return { id, name };
    })
    .filter((opt) => opt.id !== undefined && opt.id !== null && opt.id !== "");
};

const post = (path, body) => api.post(path, body).then((res) => res.data);

export const fetchCountries = () => post("/survey/countries");
export const fetchSectors = () => post("/survey/sectors");
// Confirmed against the real API docs: { "sector_id": [1428, 1429] } -
// singular key name, array value. get-states/function aren't documented as
// clearly but follow the same "Get X by Y IDs" naming, so they're assumed to
// match this same { <field>_id: [...] } convention until verified otherwise.
export const fetchIndustries = (sectorIds) => post("/survey/industries", { sector_id: sectorIds });
export const fetchStates = (countryIds) => post("/user/get-states", { country_id: countryIds });
export const fetchSectorIndustryHierarchy = () => post("/survey/sector-industry");
export const fetchCompanyNames = (search = "") => post("/company/fetch-companyNames", { search });
export const fetchCompanySizes = () => post("/survey/company-size");
export const fetchCompanyRevenues = () => post("/survey/company-revenue");
export const fetchHighestEducations = () => post("/user/highest-education");
export const fetchWorkStatuses = () => post("/user/work-status");
export const fetchPrimaryProfessions = () => post("/user/primary-profession");
export const fetchTotalWorkExperience = () => post("/user/total-work-ex");
export const fetchSeniorityLevels = () => post("/user/seniority-level");
export const fetchWorkExCurrentCompany = () => post("/user/Work-Ex-Current-Company");
export const fetchBusinessModels = () => post("/user/business-model");
export const fetchCompanyTypes = () => post("/user/company-type");
export const fetchYears = () => post("/user/years");
export const fetchHouseholdIncomes = () => post("/user/household-income");
export const fetchEmploymentStatuses = () => post("/user/employement-status");
export const fetchDepartments = () => post("/user/department");
